export default __webpack_public_path__ + "static/media/cafe.a8603741.mp3";